import React, {FunctionComponent} from 'react'
import style from './style.scss'
import {IProps} from './IProps'

const ManagePerson: FunctionComponent<IProps> = ({person, onPersonDelete}) => {
    return (
        <li className={style.managePerson}>
            <p>{person.name}</p>
            <div onClick={() => onPersonDelete(person)} className={style.removePerson}>
                <i className="icon icon-delete"></i>
            </div>
        </li>
    )
}

export default ManagePerson
